export enum HeaderTopAllowedComponents {
  HEADER_BUTTON = 'OwcHeaderButton',
}

export enum HeaderTopItems {
  HEADER_MOBILE_MENU = 'mobileMenu',
  HEADER_MODELS_MENU = 'modelsMenu',
  HEADER_FAVORITES = 'favoritesMenu',
  HEADER_MARKETPLACE = 'marketplaceItem',
  HEADER_MESSAGES = 'messagesMenu',
  HEADER_LANGUAGE_SWITCHER = 'languageSwitcher',
  HEADER_SEARCH = 'search',
}

export enum FlyoutLevels {
  FLYOUT_LEVEL_ONE = 1,
  FLYOUT_LEVEL_TWO = 2,
  FLYOUT_LEVEL_THIRD = 3,
}

export enum FlyoutInnerItemsType {
  MercedesMe = 'OwcHeaderMercedesMe',
  topic = 'OwcHeaderNavigationTopic',
  link = 'OwcHeaderNavigationLink',
  teaser = 'OwcHeaderNavigationTeaser',
  linkList = 'OwcHeaderNavigationLinkList',
  toolList = 'OwcHeaderNavigationToolList',
}
